import { render, staticRenderFns } from "./BlogContainer.vue?vue&type=template&id=c363fcc2"
import script from "./BlogContainer.vue?vue&type=script&lang=js"
export * from "./BlogContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports